import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { useAuthProvider } from "2g-auth";
import { isEmpty } from "2g-utils-common";
import { dispatchModuleAction } from "2g-utils-redux";
import { actions as formActions, useValues } from "2g-form";

import { FORM_REZERVACE_VYTVORENI_MODULE_KEY } from "../RezervaceVytvoreniForm";

export default function useRezervaceVytvoreniFormInitializer() {
  const { userInfo, zakaznik } = useAuthProvider();
  const lastZakaznik = useRef();
  const values = useValues(FORM_REZERVACE_VYTVORENI_MODULE_KEY) || {};
  const dispatch = useDispatch();

  useEffect(() => {
    if (lastZakaznik.current && values.zakaznik !== lastZakaznik.current) {
      dispatchModuleAction(
        dispatch,
        FORM_REZERVACE_VYTVORENI_MODULE_KEY,
        formActions.setValues({
          zakaznik: values.zakaznik
        })
      );
    }
    lastZakaznik.current = values.zakaznik;
  }, [values.zakaznik]);

  useEffect(() => {
    if (isEmpty(values.zakaznik) && isEmpty(values.uzivatel))
      dispatchModuleAction(
        dispatch,
        FORM_REZERVACE_VYTVORENI_MODULE_KEY,
        formActions.setValues({
          zakaznik,
          uzivatel: userInfo,
          projekt: values.projekt
        })
      );
  }, []);

  return [];
}
